import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import DataProtection from './pages/DataProtection';
import DeleteAccount from './pages/DeleteAccount';
import DriverOnboarding from './pages/DriverOnboarding';
import RestaurantOnboarding from './pages/RestaurantOnboarding';
// import RestaurantGate from './pages/RestaurantGate'; // TODO: habilitar cuando el auth esté listo
import DeepLinkHandler from './components/DeepLinkHandler';
import './App.css';

// Layout component que maneja navbar y footer condicionalmente
const Layout = ({ children }) => {
    const location = useLocation();
    const isOnboardingPage =
      location.pathname.startsWith('/repartidor') || location.pathname.startsWith('/negocio');

    if (isOnboardingPage) {
        return <>{children}</>;
    }

    return (
        <div className="App">
            <nav className="navbar">
                <div className="nav-container">
                    <Link to="/" className="nav-logo">
                        <img
                            src="/logo_jama_unido.png"
                            alt="Jama Logo"
                            className="nav-logo-img"
                        />
                    </Link>

                    <ul className="nav-menu">
                        <li className="nav-item">
                            <Link to="/" className="nav-link">Inicio</Link>
                        </li>
                        <li className="nav-item">
                            <a href="/repartidor" className="nav-link" target="_blank" rel="noopener noreferrer">Sé Repartidor</a>
                        </li>
                        <li className="nav-item">
                            <a href="/negocio" className="nav-link" target="_blank" rel="noopener noreferrer">Registra tu negocio</a>
                        </li>
                    </ul>

                    <div className="nav-actions">
                        <a href="/repartidor" className="nav-link nav-link-cta nav-link-cta-secondary" target="_blank" rel="noopener noreferrer"><span className="nav-emoji">🛵</span> Sé Repartidor</a>
                        <a href="/negocio" className="nav-link nav-link-cta" target="_blank" rel="noopener noreferrer"><span className="nav-emoji">🏪</span> Registra tu negocio</a>
                    </div>
                </div>
            </nav>

            {children}

            <footer className="footer">
                <div className="footer__top">
                    <div className="footer__brand">
                        <Link to="/" className="footer__logo-link">
                            <img src="/logo_jama_unido.png" alt="JAMA" className="footer__logo-img" />
                        </Link>
                        <p className="footer__tagline">Tu comida favorita, cuando la necesites.</p>
                        <div className="footer__socials">
                            <a href="https://www.instagram.com/jamafooddelivery/" target="_blank" rel="noopener noreferrer" className="footer__social" aria-label="Instagram">
                                <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
                            </a>
                            <a href="https://www.tiktok.com/@jamafoodelivery" target="_blank" rel="noopener noreferrer" className="footer__social" aria-label="TikTok">
                                <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.34-6.34V9.39a8.16 8.16 0 004.77 1.52V7.46a4.85 4.85 0 01-1.01-.77z"/></svg>
                            </a>
                            <a href="https://www.facebook.com/jamaecu" target="_blank" rel="noopener noreferrer" className="footer__social" aria-label="Facebook">
                                <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
                            </a>
                        </div>
                    </div>

                    <div className="footer__links">
                        <div className="footer__col">
                            <h4 className="footer__heading">Legal</h4>
                            <Link to="/privacy">Politica de Privacidad</Link>
                            <Link to="/terms">Terminos y Condiciones</Link>
                            <Link to="/data-protection">Proteccion de Datos</Link>
                        </div>
                        <div className="footer__col">
                            <h4 className="footer__heading">Unete</h4>
                            <a href="/repartidor" target="_blank" rel="noopener noreferrer">Sé Repartidor</a>
                            <a href="/negocio" target="_blank" rel="noopener noreferrer">Registra tu Negocio</a>
                        </div>
                        <div className="footer__col">
                            <h4 className="footer__heading">Contacto</h4>
                            <a href="mailto:soporte@jamaec.com">soporte@jamaec.com</a>
                        </div>
                    </div>
                </div>

                <div className="footer__bottom">
                    <p>&copy; {new Date().getFullYear()} BEEZ CIA LTDA. Todos los derechos reservados.</p>
                    <span className="footer__made-pill" aria-label="Hecho con amor en Ecuador">
                        <span className="footer__made-text">Hecho con</span>
                        <span className="footer__made-heart" aria-hidden="true">&#x2764;</span>
                        <span className="footer__made-text">en</span>
                        <span className="footer__made-flag">
                            <span style={{ color: '#FCD116' }}>E</span>
                            <span style={{ color: '#FCD116' }}>C</span>
                            <span style={{ color: '#FCD116' }}>U</span>
                            <span style={{ color: '#003893' }}>A</span>
                            <span style={{ color: '#003893' }}>D</span>
                            <span style={{ color: '#CE1126' }}>O</span>
                            <span style={{ color: '#CE1126' }}>R</span>
                        </span>
                    </span>
                </div>
            </footer>
        </div>
    );
};

function App() {
    return (
        <Router>
            <Layout>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/data-protection" element={<DataProtection />} />
                    <Route path="/eliminar-cuenta" element={<DeleteAccount />} />
                    <Route path="/delete-account" element={<DeleteAccount />} />
                    <Route path="/repartidor" element={<DriverOnboarding />} />
                    <Route path="/negocio" element={<RestaurantOnboarding />} />

                    {/* Deep Link Routes */}
                    <Route path="/ref/:code" element={<DeepLinkHandler type="referral" />} />
                    <Route path="/referral" element={<DeepLinkHandler type="referral" />} />
                    <Route path="/@:username" element={<DeepLinkHandler type="profile" />} />
                    <Route path="/food/:restaurantId" element={<DeepLinkHandler type="food" />} />
                    <Route path="/c/:code" element={<DeepLinkHandler type="coupon" />} />
                    <Route path="/p/:foodId" element={<DeepLinkHandler type="product" />} />
                    <Route path="/home" element={<DeepLinkHandler type="home" />} />
                    <Route path="/app" element={<DeepLinkHandler type="app" />} />
                </Routes>
            </Layout>
        </Router>
    );
}

export default App;
